module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><defs><style>.a{fill:none;stroke:#000;stroke-miterlimit:10;}</style></defs><title>computer</title><rect class=\"a\" x=\"2.5\" y=\"2\" width=\"45\" height=\"32\" rx=\"7.16\" ry=\"7.16\"></rect><path d=\"M0,39.5v5H50v-5ZM25,43a1,1,0,1,1,1-1A1,1,0,0,1,25,43Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/computer.svg
// module id = 510
// module chunks = 1